module.exports = __webpack_public_path__ + "img/sb.7f5f11cc.svg";